<template>
    <iframe id="if_iniModule" :src="iniPaySrc" style="width: 100%;height: 600px"></iframe>
</template>

<script>
    export default {
        name: 'iniPayReqBill_popup',
        props: ['index','param'],
        data: function(){
            return {
                payInfo 	   : {},
                basicOptInfo   : {},
                displayOptInfo : {},
                etcOptInfo 	   : {},
                callBackFunc   : null,
                iniPaySrc      : ''
            }
        },
        methods: {
            init:function(){
                const _this = this;

                var param = this.param;
                var procSe = param.procSe;

                this.callBackFunc = param.callBackFunc;

                var iniInfo = {
                    procSe: param.procSe,
                    reqstSn: param.reqstSn,
                    goodsCd: param.goodsCd,
                    goodsNm: param.goodsNm,
                    goodsMtAmount: param.goodsMtAmount,
                    goodsYearAmount: param.goodsYearAmount,
                    payMethod: 'Bill',
                    payTypeCd: param.payTypeCd,
                    paymthdCd: param.paymthdCd,
                    fcltcd: param.fcltcd,
                    mberNo: param.mberNo,
                    mberNm: param.mberNm,
                    cttpc: param.cttpc,
                    email: param.email,
                    reqDefrayDe: param.reqDefrayDe,
                    rm: param.rm,
                    mberGoodsAt : param.mberGoodsAt
                };

                if(procSe == 'getBillCardInfo'||procSe == 'srvcReq'||procSe == 'modifyTagOrder'){
                    iniInfo['payMethod'] = 'Bill';
                }else if(procSe == 'goodsPay'){
                    iniInfo['payMethod'] = 'Pay';
                    iniInfo['orderSn'] = param.orderSn;
                    iniInfo['orderPaySe'] = param.orderPaySe;
                }

                this.axios.post('/portal/srvc/srvc/setIniPayTrnsInfo.act',
                    iniInfo
                ).then(function(response) {
                    this.payInfo = response.data.iniPayInfo;
                    this.payInfo['procSe'] = param.procSe;
                    this.payInfo['reqDefrayDe'] = param.reqDefrayDe;
                    this.basicOptInfo.billPrintMsg = '고객님의 매월 결제일은 ' + param.reqDefrayDe + '일 입니다.';

                    this.sendPostMessage("init",this.payInfo);
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            iniPayReturnResultProc:function(params){
                const _this = this;

                this.axios.post('/portal/srvc/srvc/iniPayReturnResultProc.act',
                    params
                ).then(function(response) {
                    var procInfo = response.data.procInfo;

                    if(procInfo.resultCode != '0000'){
                        if(procInfo.procSe == 'goodsPay'){
                            alert('카드결제가 정상적으로 완료되지않았습니다.\n- 사유 : ' + procInfo.resultMsg);
                        }else{
                            alert('카드등록이 정상적으로 완료되지않았습니다.\n- 사유 : ' + procInfo.resultMsg);
                        }

                    }else{
                        if(_this.payInfo.procSe == 'getBillCardInfo'){
                            const billCardInfo = {
                                cardNum:procInfo.cardNum,
                                cardPass:procInfo.cardPass,
                                cardCode:procInfo.cardCode,
                                cardBankCode:procInfo.cardBankCode,
                                billkey:procInfo.billkey,
                            };
                            _this.callBackFunc(billCardInfo,_this.index);
                        }else if(_this.payInfo.procSe == 'srvcReq'){
                            _this.callBackFunc(_this.index);
                        }else if(_this.payInfo.procSe == 'modifyTagOrder'){
                            const cardInfo = {
                                billCardSn : procInfo.billCardSn
                            };
                            _this.callBackFunc(cardInfo, _this.index);
                        }else if(_this.payInfo.procSe == 'goodsPay'){
                            procInfo['tid'] = params.tid;
                            _this.callBackFunc(procInfo);
                        }
                    }

                    this.$store.commit('closePopup',this.index);

                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            postMessageReceiver : function(e){
                if(e.data.se == 'init'){
                    this.init();
                }else if(e.data.se == 'sysErr'){
                    this.$toasted.show(this.$onbiLib.msg.err.system);
                }else if(e.data.se == 'load'){
                    console.log("모듈 로딩 완료");
                }else if(e.data.se == "close"){
                    this.$store.commit('closePopup',this.index);
                }else if(e.data.se == 'return'){
                    this.iniPayReturnResultProc(e.data.params);
                }
            },
            sendPostMessage: function(se,params){
                document.getElementById('if_iniModule').contentWindow
                    .postMessage({ se: se,params:params },"*");
            }
        },
        mounted: function() {
            this.iniPaySrc = '/portal/srvc/srvc/iniPayReqBill.on';
            if(window.iniPayReqBillPopupEventListner){
                window.removeEventListener('message', window.iniPayReqBillPopupEventListner, false);
            }

            window.addEventListener('message', this.postMessageReceiver, false);
            window.iniPayReqBillPopupEventListner = this.postMessageReceiver;
        }
    }
</script>

<style scoped>

</style>
